import { IApplicationState } from '@bridebook/web/lib/types';
import { getBookedVenue } from '@bridebook/web/lib/shortlist/selectors';
import { getVenueBooked } from '@bridebook/web/lib/weddings/selectors';
import { MobileFlowAssignment } from './config';
import {
  ASSIGNMENT_VENUE_NOT_SELECTED_TASK_DEFINITION,
  ASSIGNMENT_VENUE_SELECTED_TASK_DEFINITION,
} from './task-definitions';

export const getMobileAssignmentFromTasks = (
  state: IApplicationState,
): MobileFlowAssignment | null => {
  const todayTasks = state.task.todayTasks;
  if (todayTasks.status !== 'loaded' && todayTasks.status !== 'partiallyLoaded') return null;
  const weddingTasks = todayTasks.wedding;
  if (!weddingTasks) return null;

  if (weddingTasks[ASSIGNMENT_VENUE_SELECTED_TASK_DEFINITION.id]?.done) return 'venueSelected';
  if (weddingTasks[ASSIGNMENT_VENUE_NOT_SELECTED_TASK_DEFINITION.id]?.done)
    return 'venueNotSelected';
  return null;
};

/**
 * Resolves assignment without caching. Priority:
 *   1. Assignment tasks in Firestore (persisted by mobileAssignmentEpic)
 *   2. Derived from current venue booking status
 *
 * The assignment epic marks the correct assignment task after the user leaves onboarding,
 * so step 2 is only used briefly for brand-new accounts before the epic fires.
 * The listener's distinctUntilChanged handles any transient changes.
 */
export const resolveMobileAssignment = (state: IApplicationState): MobileFlowAssignment => {
  // 1. Assignment tasks (Firestore — most authoritative, persisted by assignment epic)
  const assignmentFromTasks = getMobileAssignmentFromTasks(state);
  if (assignmentFromTasks) {
    return assignmentFromTasks;
  }

  // 2. Derive from current state — no caching, always reflects latest data
  const venueBookedFlag = getVenueBooked(state);
  const bookedVenue = getBookedVenue(state);
  const venueBooked = Boolean(venueBookedFlag) || Boolean(bookedVenue);
  return venueBooked ? 'venueSelected' : 'venueNotSelected';
};
